<div class="layout-footer">
    Pampa intranet by
    <a href="https://x.com" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">FutPro</a>
</div>
